exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hotel-characteristics {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n}\n.hotel-characteristics div {\n  width: 20%;\n  min-width: 55px;\n  max-width: 79px;\n  padding: 10px 0;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n}\n.hotel-characteristics div img {\n  background-color: white;\n  border: none;\n  width: 45px;\n  height: 45px;\n}\n.hotel-characteristics div p {\n  text-align: center;\n  margin-top: 6px;\n  font-size: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/hotels/components/Characteristics.less
// module id = 1366
// module chunks = 0